export default __webpack_public_path__ + "static/media/1324.e05b0b7d.png";